<h2>My Exposure</h2>

<p *ngIf="error" style="color: red" [innerHTML]="error"></p>

<p *ngIf="!resultsAvailable">
  Please wait while we gather the information needed to calculate your exposure.<br>
  Weather data... {{ weatherStatus }}<br>
  Air monitor data... {{ airPollutionStatus }}<br>
</p>

<h3 *ngIf="resultsAvailable">Results for {{ startDate | date: 'longDate'}}, {{ startDate | date: 'shortTime' }} through {{ endDate | date: 'longDate'}}, {{ endDate | date: 'shortTime' }}</h3>

<p *ngIf="resultsAvailable">
  <button class="usa-button usa-button--accent-warm" type="button" (click)="download()" [disabled]="!resultsAvailable">Download Results</button>
</p>

<google-chart *ngIf="resultsAvailable"
  [type]="envPM25ExpPie.type"
  [options]="envPM25ExpPie.options"
  [data]="envPM25ExpPie.data"
  [width]="envPM25ExpPie.width"
  [height]="envPM25ExpPie.height">
</google-chart>

<table *ngIf="resultsAvailable" class="usa-table usa-table--borderless">
  <caption>{{ envPM25ExpPie.options.title }}</caption>
  <thead>
    <tr>
      <th scope="col">Location</th>
      <th scope="col">Amount of PM2.5 Exposure (%)</th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let data of envPM25ExpPie.data">
      <td>{{ data[0] }}</td>
      <td style="text-align: right">{{ data[1] }}%</td>
    </tr>
  </tbody>
</table>

<google-chart *ngIf="resultsAvailable"
  [type]="envOzoneExpPie.type"
  [options]="envOzoneExpPie.options"
  [data]="envOzoneExpPie.data"
  [width]="envOzoneExpPie.width"
  [height]="envOzoneExpPie.height">
</google-chart>

<table *ngIf="resultsAvailable" class="usa-table usa-table--borderless">
  <caption>{{ envOzoneExpPie.options.title }}</caption>
  <thead>
    <tr>
      <th scope="col">Location</th>
      <th scope="col">Amount of Ozone Exposure (%)</th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let data of envOzoneExpPie.data">
      <td>{{ data[0] }}</td>
      <td style="text-align: right">{{ data[1] }}%</td>
    </tr>
  </tbody>
</table>

<google-chart *ngIf="resultsAvailable"
  [type]="pm25ExposureColumn.type"
  [options]="pm25ExposureColumn.options"
  [data]="pm25ExposureColumn.data"
  [width]="pm25ExposureColumn.width"
  [height]="pm25ExposureColumn.height">
</google-chart>

<table *ngIf="resultsAvailable" class="usa-table usa-table--borderless">
  <caption>{{ pm25ExposureColumn.options.title }}</caption>
  <thead>
    <tr>
      <th scope="col">Date</th>
      <th scope="col">Change in PM2.5 Exposure (%)</th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let data of pm25ExposureColumn.data">
      <td>{{ data[0] | date: 'longDate' }}</td>
      <td style="text-align: right">{{ data[1] }}%</td>
    </tr>
  </tbody>
</table>

<google-chart *ngIf="resultsAvailable"
  [type]="ozoneExposureColumn.type"
  [options]="ozoneExposureColumn.options"
  [data]="ozoneExposureColumn.data"
  [width]="ozoneExposureColumn.width"
  [height]="ozoneExposureColumn.height">
</google-chart>

<table *ngIf="resultsAvailable" class="usa-table usa-table--borderless">
  <caption>{{ ozoneExposureColumn.options.title }}</caption>
  <thead>
    <tr>
      <th scope="col">Date</th>
      <th scope="col">Change in Ozone Exposure (%)</th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let data of ozoneExposureColumn.data">
      <td>{{ data[0] | date: 'longDate' }}</td>
      <td style="text-align: right">{{ data[1] }}%</td>
    </tr>
  </tbody>
</table>

<!-- <h2>Summary</h2>

<table>
  <tr>
    <td>Start</td>
    <td>{{ startDate | date: 'short'}}</td>
  </tr>
  <tr>
    <td>End</td>
    <td>{{ endDate | date: 'short'}}</td>
  </tr>
  <tr>
    <td>&nbsp;</td>
    <td>&nbsp;</td>
  </tr>
  <tr>
    <td>PM2.5 exposure</td>
    <td>{{ pm25Exposures[0] | number:'.1-1' }} &micro;g/m<sup>3</sup></td>
  </tr>
  <tr>
    <td>Ozone exposure</td>
    <td>{{ ozoneExposures[0] | number:'.2-2' }} ppb</td>
  </tr>
  <tr>
    <td>&nbsp;</td>
    <td>&nbsp;</td>
  </tr>
  <tr>
    <td>PM2.5 dose per body surface area</td>
    <td>{{ pm25Doses[0] | number:'.1-1' }} &micro;g/m<sup>2</sup></td>
  </tr>
  <tr>
    <td>Ozone dose per body surface area</td>
    <td>{{ ozoneDoses[0] | number:'.1-1' }} &micro;g/m<sup>2</sup></td>
  </tr>
</table>

<h2>Details</h2>

<table>
  <tr>
    <td>Location</td>
    <td>
      <span *ngIf="loadingLocation">Loading...</span>
      <span *ngIf="!loadingLocation">
        {{ latitude | number:'.2-2' }}, {{ longitude | number:'.2-2' }}
      </span>
    </td>
  </tr>
  <tr>
    <td>Outdoor PM2.5</td>
    <td>
      <span *ngIf="loadingAirPollution">Loading...</span>
      <span *ngIf="!loadingAirPollution">
        {{ outdoorPM25Values[0] | number:'.1-1' }} &micro;g/m<sup>3</sup>
      </span>
    </td>
  </tr>
  <tr>
    <td>Outdoor ozone</td>
    <td>
      <span *ngIf="loadingAirPollution">Loading...</span>
      <span *ngIf="!loadingAirPollution">
        {{ outdoorOzoneValues[0] | number:'.2-2' }} ppb
      </span>
    </td>
  </tr>
  <tr>
    <td>&nbsp;</td>
    <td>&nbsp;</td>
  </tr>
  <tr>
    <td>Outdoor temperature</td>
    <td>
      <span *ngIf="loadingWeather">Loading...</span>
      <span *ngIf="!loadingWeather">
        {{ weatherConditions[0].temperature | number:'.1-1' }} &deg;C
      </span>
    </td>
  </tr>
  <tr>
    <td>Outdoor wind speed</td>
    <td>
      <span *ngIf="loadingWeather">Loading...</span>
      <span *ngIf="!loadingWeather">
        {{ weatherConditions[0].windSpeed | number:'.1-1' }} km/hr
      </span>
    </td>
  </tr>
  <tr>
    <td>Outdoor humidity</td>
    <td>
      <span *ngIf="loadingWeather">Loading...</span>
      <span *ngIf="!loadingWeather">
        {{ weatherConditions[0].humidity | number:'.1-1' }}%
      </span>
    </td>
  </tr>
  <tr>
    <td>&nbsp;</td>
    <td>&nbsp;</td>
  </tr>
  <tr>
    <td>Home air exchange rate</td>
    <td>{{ homeAirExchangeRateValues[0] | number:'.2-2' }}/hr</td>
  </tr>
  <tr>
    <td>Home PM2.5 infiltration factor</td>
    <td>{{ homePM25InfiltrationFactors[0] | number:'.2-2' }}</td>
  </tr>
  <tr>
    <td>Home ozone infiltration factor</td>
    <td>{{ homeOzoneInfiltrationFactors[0] | number:'.2-2' }}</td>
  </tr>
  <tr>
    <td>Home indoor PM2.5 level</td>
    <td>{{ homeIndoorPM25Levels[0] | number:'.1-1' }} &micro;g/m<sup>3</sup></td>
  </tr>
  <tr>
    <td>Home indoor ozone level</td>
    <td>{{ homeIndoorOzoneLevels[0] | number:'.2-2' }} ppb</td>
  </tr>
  <tr>
    <td>&nbsp;</td>
    <td>&nbsp;</td>
  </tr>
  <tr>
    <td>Personal PM2.5 exposure factor</td>
    <td>{{ personalPM25ExposureFactors[0] | number:'.2-2' }}</td>
  </tr>
  <tr>
    <td>Personal ozone exposure factor</td>
    <td>{{ personalOzoneExposureFactors[0] | number:'.2-2' }}</td>
  </tr>
  <tr>
    <td>&nbsp;</td>
    <td>&nbsp;</td>
  </tr>
  <tr>
    <td>Exposed temperature</td>
    <td>{{ exposedTemperatures[0] | number:'.1-1' }} &deg;C</td>
  </tr>
  <tr>
    <td>Exposed humidity</td>
    <td>{{ exposedHumidities[0] | number:'.1-1' }}%</td>
  </tr>
  <tr>
    <td>Exposed heat index</td>
    <td>{{ exposedHeatIndexes[0] | number:'.1-1' }} &deg;C<td>
  </tr>
</table> -->

<!-- <h3>Microenvironment exposures</h3>

<table>
  <tr>
    <th>Microenvironment</th>
    <th>Time spent</th>
    <th>PM2.5 exposure</th>
    <th>PM2.5 dose</th>
    <th>Ozone exposure</th>
    <th>Ozone dose</th>
  </tr>
  <tr>
    <td>Outdoors</td>
  </tr>
  <tr>
    <td>Inside vehicles</td>
  </tr>
  <tr>
    <td>Indoors not at home</td>
  </tr>
  <tr>
    <td>Indoors at home</td>
  </tr>
</table>

<p>Time spend doing physical activity</p> -->

<p>
  <button class="usa-button usa-button--secondary" type="button" routerLink="/" skipLocationChange>Back to Home</button>
</p>
